import {useBanners} from 'api/queries';
import {useRouter} from 'next/router';
import React, {FC} from 'react';
import {IBannersResponse, QueryKeyEnum} from 'types';

import {Banners} from './components';

interface IProps {
  providerType?: string;
  initialBanners?: IBannersResponse[];
}

export const BannersWithSlider: FC<IProps> = React.memo(({providerType, initialBanners}) => {
  const {locale} = useRouter();
  const {data: banners = [], isLoading: isLoadingBanners} = useBanners(
    [QueryKeyEnum.BANNERS, locale, providerType],
    {
      provider_type__in: `${providerType},any`,
    },
    {enabled: !!providerType, locale, initialData: initialBanners},
  );

  return <Banners banners={banners} isLoading={isLoadingBanners} />;
});
